import React from 'react'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { ShortcutKbd } from '@/components/ui/shortcut-kbd'
import { DesktopSubmenu } from './desktop-submenu'

export const DesktopHelpMenu: React.FC = () => {
  return (
    <DesktopSubmenu label="Help" sideOffset={0} alignOffset={4}>
      <DropdownMenuItem>About</DropdownMenuItem>
      <DropdownMenuItem>Help</DropdownMenuItem>
      <DropdownMenuItem>Contact Support</DropdownMenuItem>
      <DropdownMenuItem>
        Shortcuts
        <ShortcutKbd shortcutKey="shortcuts" />
      </DropdownMenuItem>
    </DesktopSubmenu>
  )
}
